import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'unistore/full/react';
import actions from './actions';

export default connect(
  ['user'],
  actions
)(function PlaybackSettings({ user }) {
  const history = useHistory();

  return (
    <div className="Content">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 375 50"
        style={{
          position: 'fixed',
          top: '0',
          backdropFilter: 'blur(20px)',
        }}
      >
        <g onClick={() => history.goBack()}>
          <path fill="#181818" d="M0 0H375V50H0z" fillOpacity="0.7"></path>
          <text
            fill="#fff"
            style={{ whiteSpace: 'pre' }}
            fontSize="16"
            fontWeight="bold"
            letterSpacing="0em"
          >
            <tspan x="153.211" y="31.24">
              Playback
            </tspan>
          </text>
          <path
            fill="#fff"
            d="M27.521 19.38l-.65-.76L18.23 26l8.641 7.38.65-.76L19.77 26l7.751-6.62z"
          ></path>
        </g>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 375 1018"
      >
        <path fill="#121212" d="M0 0H375V1018H0z"></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="559.24">
            Loud (might reduce dynamics)
          </tspan>
        </text>
        <path
          fill="#B3B3B3"
          d="M348.129 690.62l-.65.76 7.752 6.62-7.752 6.62.65.76 8.642-7.38-8.642-7.38z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="703.24">
            Equalizer
          </tspan>
        </text>
        <path
          fill="#1DB954"
          d="M356.985 596.383l-8.858 10.371-3.739-4.379-.658.77 4.397 5.149 9.618-11.262-.76-.649z"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="607.24">
            Normal
          </tspan>
        </text>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="655.24">
            Quiet (preserves dynamic)
          </tspan>
        </text>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="24"
          fontWeight="bold"
          letterSpacing="-.04em"
        >
          <tspan x="16" y="513.86">
            Volume level
          </tspan>
        </text>
        <text
          fill="#fff"
          fillOpacity="0.7"
          style={{ whiteSpace: 'pre' }}
          fontSize="13"
          fontWeight="450"
          letterSpacing="0"
        >
          <tspan x="16" y="354.257">
            Allows smooth transitions between songs in a playlist.
          </tspan>
        </text>
        <path
          fill="#1DB954"
          fillRule="evenodd"
          d="M323.168 250.095c1.774-.103 3.546-.095 5.32-.095h8.99c1.809 0 3.581-.008 5.354.095 1.612.093 3.182.291 4.745.734a15.56 15.56 0 018.241 5.633 15.853 15.853 0 013.182 9.537 15.85 15.85 0 01-3.182 9.539 15.566 15.566 0 01-8.241 5.633c-1.563.443-3.133.64-4.745.734-1.773.103-3.545.094-5.319.094l-8.992.001c-1.807-.001-3.579.008-5.353-.095-1.611-.094-3.181-.291-4.744-.734a15.566 15.566 0 01-8.241-5.633A15.857 15.857 0 01307 266c0-3.445 1.119-6.798 3.183-9.538a15.56 15.56 0 018.241-5.633c1.563-.443 3.133-.641 4.744-.734z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M343 280c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z"
          clipRule="evenodd"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="271.24">
            Gapless Playback
          </tspan>
        </text>
        <path
          fill="#282828"
          fillRule="evenodd"
          d="M323.168 58.095c1.774-.103 3.546-.095 5.32-.095h8.99c1.809 0 3.581-.008 5.354.095 1.612.093 3.182.291 4.745.734a15.559 15.559 0 018.241 5.633A15.853 15.853 0 01359 74c0 3.448-1.117 6.8-3.182 9.54a15.566 15.566 0 01-8.241 5.632c-1.563.443-3.133.64-4.745.734-1.773.103-3.545.094-5.319.094l-8.992.001c-1.807-.001-3.579.008-5.353-.095-1.611-.094-3.181-.291-4.744-.734a15.566 15.566 0 01-8.241-5.633A15.857 15.857 0 01307 74a15.86 15.86 0 013.183-9.538 15.559 15.559 0 018.241-5.633c1.563-.443 3.133-.641 4.744-.734z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M323 88c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z"
          clipRule="evenodd"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="79.24">
            Offline
          </tspan>
        </text>
        <path
          fill="#1DB954"
          fillRule="evenodd"
          d="M323.168 298.095c1.774-.103 3.546-.095 5.32-.095h8.99c1.809 0 3.581-.008 5.354.095 1.612.093 3.182.291 4.745.734a15.56 15.56 0 018.241 5.633 15.853 15.853 0 013.182 9.537 15.85 15.85 0 01-3.182 9.539 15.566 15.566 0 01-8.241 5.633c-1.563.443-3.133.64-4.745.734-1.773.103-3.545.094-5.319.094l-8.992.001c-1.807-.001-3.579.008-5.353-.095-1.611-.094-3.181-.291-4.744-.734a15.566 15.566 0 01-8.241-5.633A15.857 15.857 0 01307 314c0-3.445 1.119-6.798 3.183-9.538a15.56 15.56 0 018.241-5.633c1.563-.443 3.133-.641 4.744-.734z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M343 328c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z"
          clipRule="evenodd"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="319.24">
            Automix
          </tspan>
        </text>
        <text
          fill="#fff"
          fillOpacity="0.7"
          style={{ whiteSpace: 'pre' }}
          fontSize="13"
          fontWeight="450"
          letterSpacing="0"
        >
          <tspan x="16" y="994.257">
            Display short, looping visuals on tracks.
          </tspan>
        </text>
        <text
          fill="#fff"
          fillOpacity="0.7"
          style={{ whiteSpace: 'pre' }}
          fontSize="13"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="834.257">
            Mix in recommendation picked just for you.{' '}
          </tspan>
        </text>
        <path
          fill="#1DB954"
          fillRule="evenodd"
          d="M323.168 938.095c1.774-.103 3.546-.095 5.32-.095h8.99c1.809 0 3.581-.008 5.354.095 1.612.093 3.182.291 4.745.734a15.56 15.56 0 018.241 5.633 15.853 15.853 0 013.182 9.537 15.85 15.85 0 01-3.182 9.539 15.566 15.566 0 01-8.241 5.633c-1.563.443-3.133.64-4.745.734-1.773.103-3.545.094-5.319.094l-8.992.001c-1.807-.001-3.579.008-5.353-.095-1.611-.094-3.181-.291-4.744-.734a15.566 15.566 0 01-8.241-5.633A15.857 15.857 0 01307 954c0-3.445 1.119-6.798 3.183-9.538a15.56 15.56 0 018.241-5.633c1.563-.443 3.133-.641 4.744-.734z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M343 968c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z"
          clipRule="evenodd"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="959.24">
            Canvas
          </tspan>
        </text>
        <path
          fill="#1DB954"
          fillRule="evenodd"
          d="M323.168 378.095c1.774-.103 3.546-.095 5.32-.095h8.99c1.809 0 3.581-.008 5.354.095 1.612.093 3.182.291 4.745.734a15.56 15.56 0 018.241 5.633 15.853 15.853 0 013.182 9.537 15.85 15.85 0 01-3.182 9.539 15.566 15.566 0 01-8.241 5.633c-1.563.443-3.133.64-4.745.734-1.773.103-3.545.094-5.319.094l-8.992.001c-1.807-.001-3.579.008-5.353-.095-1.611-.094-3.181-.291-4.744-.734a15.566 15.566 0 01-8.241-5.633A15.857 15.857 0 01307 394c0-3.445 1.119-6.798 3.183-9.538a15.56 15.56 0 018.241-5.633c1.563-.443 3.133-.641 4.744-.734z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M343 408c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z"
          clipRule="evenodd"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="399.24">
            Hide Unplayable Songs
          </tspan>
        </text>
        <path
          fill="#1DB954"
          fillRule="evenodd"
          d="M323.168 426.095c1.774-.103 3.546-.095 5.32-.095h8.99c1.809 0 3.581-.008 5.354.095 1.612.093 3.182.291 4.745.734a15.56 15.56 0 018.241 5.633 15.853 15.853 0 013.182 9.537 15.85 15.85 0 01-3.182 9.539 15.566 15.566 0 01-8.241 5.633c-1.563.443-3.133.64-4.745.734-1.773.103-3.545.094-5.319.094l-8.992.001c-1.807-.001-3.579.008-5.353-.095-1.611-.094-3.181-.291-4.744-.734a15.566 15.566 0 01-8.241-5.633A15.857 15.857 0 01307 442c0-3.445 1.119-6.798 3.183-9.538a15.56 15.56 0 018.241-5.633c1.563-.443 3.133-.641 4.744-.734z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M343 456c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z"
          clipRule="evenodd"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="447.24">
            Enable Audio Normalization
          </tspan>
        </text>
        <path
          fill="#282828"
          fillRule="evenodd"
          d="M323.168 730.095c1.774-.103 3.546-.095 5.32-.095h8.99c1.809 0 3.581-.008 5.354.095 1.612.093 3.182.291 4.745.734a15.56 15.56 0 018.241 5.633 15.853 15.853 0 013.182 9.537 15.85 15.85 0 01-3.182 9.539 15.566 15.566 0 01-8.241 5.633c-1.563.443-3.133.64-4.745.734-1.773.103-3.545.094-5.319.094l-8.992.001c-1.807-.001-3.579.008-5.353-.095-1.611-.094-3.181-.291-4.744-.734a15.566 15.566 0 01-8.241-5.633A15.857 15.857 0 01307 746c0-3.445 1.119-6.798 3.183-9.538a15.56 15.56 0 018.241-5.633c1.563-.443 3.133-.641 4.744-.734z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M323 760c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z"
          clipRule="evenodd"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="751.24">
            Play Feedback Sounds
          </tspan>
        </text>
        <text
          fill="#fff"
          fillOpacity="0.7"
          style={{ whiteSpace: 'pre' }}
          fontSize="13"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="906.257">
            Enjoy nonstop music. We’ll play you similar songs when{' '}
          </tspan>
          <tspan x="16" y="922.257">
            your music ends.
          </tspan>
        </text>

        <path
          fill="#1DB954"
          fillRule="evenodd"
          d="M323.168 850.095c1.774-.103 3.546-.095 5.32-.095h8.99c1.809 0 3.581-.008 5.354.095 1.612.093 3.182.291 4.745.734a15.56 15.56 0 018.241 5.633 15.853 15.853 0 013.182 9.537 15.85 15.85 0 01-3.182 9.539 15.566 15.566 0 01-8.241 5.633c-1.563.443-3.133.64-4.745.734-1.773.103-3.545.094-5.319.094l-8.992.001c-1.807-.001-3.579.008-5.353-.095-1.611-.094-3.181-.291-4.744-.734a15.566 15.566 0 01-8.241-5.633A15.857 15.857 0 01307 866c0-3.445 1.119-6.798 3.183-9.538a15.56 15.56 0 018.241-5.633c1.563-.443 3.133-.641 4.744-.734z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M343 880c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z"
          clipRule="evenodd"
        ></path>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="16"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="871.24">
            Autoplay
          </tspan>
        </text>
        <rect
          width="296"
          height="2"
          x="40"
          y="221"
          fill="#535353"
          rx="1"
        ></rect>
        <rect width="64" height="2" x="40" y="221" fill="#1DB954" rx="1"></rect>
        <path fill="#fff" d="M96 222a8 8 0 0116 0 8 8 0 01-16 0z"></path>
        <text
          fill="#B3B3B3"
          style={{ whiteSpace: 'pre' }}
          fontSize="11"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="343.574" y="225.602">
            12s
          </tspan>
        </text>
        <text
          fill="#B3B3B3"
          style={{ whiteSpace: 'pre' }}
          fontSize="11"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="225.602">
            0s
          </tspan>
        </text>
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="24"
          fontWeight="bold"
          letterSpacing="-.04em"
        >
          <tspan x="16" y="185.86">
            Crossfade
          </tspan>
        </text>
        <text
          fill="#fff"
          fillOpacity="0.7"
          style={{ whiteSpace: 'pre' }}
          fontSize="13"
          fontWeight="450"
          letterSpacing="0em"
        >
          <tspan x="16" y="114.257">
            When you go offline, you’ll only be able to play music and{' '}
          </tspan>
          <tspan x="16" y="130.257">
            podcasts you’ve downloaded.
          </tspan>
        </text>
      </svg>
    </div>
  );
});
